import orcidLogo from "../../assets/orcid.logo.icon.svg";
import styles from "./ORCIDLoginButton.module.css";

const ORCIDLoginButton = () => {
  const handleClick = () => {
    globalThis.location.assign(
      `${import.meta.env.VITE_ORCID_OAUTH_ENDPOINT}?client_id=${import.meta.env.VITE_ORCID_OAUTH_CLIENT_ID}&response_type=code&scope=/authenticate%20&redirect_uri=${import.meta.env.VITE_ORCID_OAUTH_SUCCESS_REDIRECT_URI}?origin=/`
    );
  };

  return (
    <button type="button" className={styles.loginButton} onClick={handleClick}>
      <img src={orcidLogo} width="20px" height="20px" /> Sign in with ORCID
    </button>
  );
};

export default ORCIDLoginButton;
